import { Level2, Level3 } from '../StyledOl';

import GeneralWarrenties from './GeneralWarrenties';
import PurchasePriceAndPaymentTerms from './PurchasePriceAndPaymentTerms';
import Testing from './Testing';
import WarrantyPeriod from './WarrantyPeriod';

const TermsAndConditions = () => (
  <>
    <li>
      CONTRACTOR&rsquo;S OBLIGATIONS
      <Level2>
        <li>
          LINK hereby appoints the Contractor and the Contractor hereby agrees to undertake the
          following obligations under this Purchase Order:
          <Level3>
            <li>
              Supply and deliver the Goods free from all encumbrances and/or Services to LINK
              strictly in accordance to this Purchase Order free from all encumbrances;
            </li>
            <li>
              Where applicable, install, test, integrate, commission and deploy the Goods in
              accordance with the Specifications;
            </li>
            <li>
              Where applicable, carry out Acceptance Tests in accordance with the Specifications;
            </li>
            <li>
              Where applicable, provide the Documentation in accordance with the Specifications;
            </li>
            <li>Where applicable, provide the training in accordance with the Specifications;</li>
            <li>
              Perform the Services specified in the Specifications for the duration of the Purchase
              Order in accordance with the timelines agreed between the Parties; and
            </li>
            <li>
              Do all things which are necessary or reasonably to be inferred from this Purchase
              Order.
            </li>
          </Level3>
        </li>
      </Level2>
    </li>
    <PurchasePriceAndPaymentTerms />
    <li>
      PACKAGING AND DELIVERY
      <Level2>
        <li>
          Where applicable, the Contractor shall be responsible for delivering the Goods and/or
          Service to the Site and shall ensure that:
          <Level3>
            <li>
              no damage is done to the Site (including building structures, fittings, furniture,
              equipment and floors) and to restore any and all damaged parts of the Site to their
              original condition or replace such damaged Goods as necessary; and
            </li>
            <li>
              the safety and security of the Site, LINK&rsquo;s staff, employees, visitors are not
              compromised in the process.
            </li>
          </Level3>
        </li>
      </Level2>
    </li>
    <li>
      TIME OF DELIVERY/PERFORMANCE OF SERVICES
      <Level2>
        <li>
          Time is of the essence in this Purchase Order. The Contractor shall supply and deliver the
          Goods purchased by LINK to the Site and perform the Services in accordance with the
          timelines agreed between the Parties.
        </li>
        <li>
          LINK shall have the sole discretion to alter or delay delivery subject to providing a
          reasonable notice to the Contractor.
        </li>
        <li>
          In the event the Contractor fails to deliver the Goods and/or Services to the Site in
          accordance with the agreed timelines including due to non-delivery or, default in shipment
          due to labor disputes, transportation shortage, delays in receipt of material, priorities,
          fires, accidents, LINK shall treat this to be a material breach of the Purchase Order. In
          the event such circumstances arises, LINK shall be entitled to terminate the Purchase
          Order at its sole discretion with no liability to the Contractor and the Contractor shall
          make a full refund of all sums paid by the Purchaser pursuant to this Contract within
          fourteen (14) days from the date of termination.
        </li>
        <li>
          In order to assist in the coordination and execution of the Specification, the Contractor
          shall appoint an individual (&ldquo;&nbsp;
          <strong>Contractor Representative</strong>&rdquo;) who will have the authority to act on
          behalf of the Contractor, and who shall be solely dedicated for LINK and with whom LINK
          may consult, at reasonable times and whose instructions, requests and decisions,
          consistent with this Purchase Order, will be binding upon the Contractor as to all matters
          pertaining to this Purchase Order and performance of this Service.
        </li>
        <li>
          The Contractor warrants and represents that the Service will be performed using its own
          original materials, software, inventions or innovations (&ldquo;
          <strong>Materials</strong>&rdquo;) or if using third party&rsquo;s Materials, that it has
          the necessary and valid consent or license duly obtained from the Materials&rsquo; owners.
        </li>
      </Level2>
    </li>
    <GeneralWarrenties />
    <Testing />
    <li>
      DOCUMENTATION (IF APPLICABLE)
      <Level2>
        <li>
          The Contractor shall provide LINK with such manuals, documentation and other materials as
          may be necessary to allow LINK to understand, access and use the deliverables supplied by
          the Contractor as part of the Goods and/or Services effectively and efficiently, and such
          other materials as may be further specified in the Specifications. Without limitation,
          such material must:
          <Level3>
            <li>be of a reasonable standard of accuracy, presentation and scope;</li>
            <li>be the most current version available; and</li>
            <li>
              contain such information as would reasonably be required by any person wishing to use
              the end-result/deliverables of the Goods and/or Services.
            </li>
          </Level3>
        </li>
        <li>
          The&nbsp;Contractor&rsquo;s failure to supply the documentation in accordance with the
          requirements of Clause 9.1 above and/or those requirements set out in the Specifications
          shall be construed as an incomplete delivery of the Goods and/or Services.
        </li>
        <li>
          The Contractor may be required to review with LINK any technical recommendations, reports
          or otherwise as required by LINK.
        </li>
      </Level2>
    </li>
    <li>
      TRAINING (IF APPLICABLE)
      <Level2>
        <li>
          The Contractor shall provide training to LINK&rsquo;s nominated personnel in accordance
          with the requirements specified in the Specification&nbsp;s and/or such other
          requirements, to enable LINK to properly and effectively use the Goods and/or Service, as
          may be agreed between the Parties in writing at no further costs to LINK.
        </li>
        <li>
          The Contractor shall provide adequate training documents, literature and other materials
          for all trainees attending such training. All training material shall be in clear and
          properly written English. A complete set of training materials shall be made available to
          LINK in a soft copy format that is acceptable to LINK. LINK shall have the right to use
          such materials to conduct internal training. Any costs associated to such training will be
          absorbed and borne by the Contractor.
        </li>
      </Level2>
    </li>
    <li>
      COMMISSIONING DATE (IF APPLICABLE)
      <Level2>
        <li>
          A certificate&nbsp;or other confirmation commissioning the Goods and/or Service will only
          be issued by LINK upon the following:
          <Level3>
            <li>successful completion of all Acceptance Tests and LINK Acceptance Tests;</li>
            <li>
              the completion of all obligations required to be completed before commissioning of the
              Goods and/or Service; and
            </li>
            <li>
              the receipt by LINK of all Documentation and materials required to be provided by the
              Contractor to LINK before commissioning of the Goods and/or Service,
              <br />
              and the Goods and/or Service shall be ready for use by LINK as of the date of such
              certificate or confirmation (&ldquo;
              <strong>Commissioning Date</strong>
              &nbsp;&rdquo;). LINK shall have absolute discretion not to issue and sign such
              certificate if the Goods and/or Service as a whole does not perform in accordance with
              the Specifications or in a manner satisfactory to LINK.
            </li>
          </Level3>
        </li>
        <li>
          The Contractor shall remain liable to LINK in accordance with the terms and conditions
          contained herein notwithstanding the issuance and signing by LINK of any such certificate,
          confirmation or document or any payment. Such certificate, confirmation, document or
          payment shall have no legal effect other than serving as a declaration to the Contractor
          that LINK is ready to proceed with the next phase of this Purchase Order .
        </li>
      </Level2>
    </li>
    <li>
      TITLE AND RISK
      <Level2>
        <li>
          The Title in the Goods shall pass to LINK at the time when the Goods are delivered to the
          destination and only upon acceptance of the Goods by LINK after inspection or successful
          commissioning. The Goods shall remain at the Contractor's risk until acceptance by LINK.
        </li>
      </Level2>
    </li>
    <WarrantyPeriod />
    <li>
      GIFTS, INDUCEMENTS OR REWARDS
      <Level2>
        <li>
          LINK may terminate the Purchase Order and recover from the Contractor the amount of any
          loss resulting from such termination, if the Contractor shall have offered or given or
          agreed to give to any person any gift or consideration of any kind as an inducement or
          reward for doing to forbearing to do or for having done or forborne to do any action in
          relation to the obtaining or execution of the Purchase Order with LINK or for showing or
          forbearing to show favour to any person in relation to any Purchase Order with LINK, or if
          the like acts shall have been done by any person employed by the Contractor or acting
          on&nbsp;its behalf (whether with or without the knowledge of the Contractor) or if in
          relation to any Purchase Order with LINK, the Contractor or any person employed by it or
          acting on its behalf shall have committed any offence under the relevant provisions
          prevailing laws Act or shall have abetted or attempted to commit such an offence or shall
          have given any fee or reward the receipt of which is an offence under the relevant
          provisions of prevailing laws.
        </li>
      </Level2>
    </li>
    <li>
      SUB-CONTRACTING AND ASSIGNING
      <Level2>
        <li>
          The Contractor shall not sub-contract or assign the Purchase Order without the written
          consent of LINK.
        </li>
      </Level2>
    </li>
    <li>
      FORCE MAJEURE EVENT
      <Level2>
        <li>
          Neither Party will be liable for any failure or delay in performing any of its obligations
          under this Purchase Order if and to the extent the failure or delay is directly due to one
          of the following: fire, flood, elements of nature, acts of God, health epidemics declared
          by the World Health Organisation, acts of war, terrorism or civil unrest, industrial
          action or any other similar events beyond its reasonable control which affects the general
          public (each a &ldquo;Force Majeure Event&rdquo;) provided that the Party affected by the
          Force Majeure Event is without fault and the failure or delay could not have been
          prevented by reasonable precautions.
        </li>
        <li>
          Subject to the Party who has been delayed promptly telling the other Party in writing of
          the reasons of the delay and the likely duration of the delay; and using reasonable
          efforts to perform its obligations under this Purchase Order or to mitigate the impact of
          its non-performance, notwithstanding the Force Majeure Event, the performance of that
          Party's obligations will be suspended during the period that those circumstances persist
          and that Party will be granted an extension of time for performance equal to the period of
          the delay.
        </li>
        <li>
          If the Force Majeure Event shall continue for a period exceeding thirty (30) days or the
          extension of time granted under this clause exceeds thirty (30) days in the aggregate,
          either Party may terminate this Purchase Order by giving seven (7) days' prior written
          notice to the other Party without being liable therefore in damages or compensation.
        </li>
      </Level2>
    </li>
    <li>
      REPLACEMENT AND NUMBER OF PERSONNEL (IF APPLICABLE)
      <Level2>
        <li>
          Without prejudice to LINK&rsquo;s other rights under this Purchase Order , LINK may issue
          a written notice to the Contractor that any or all of its employees, consultants,
          sub-contractors, suppliers and agents (collectively &ldquo;Personnel&rdquo;) of the
          Contractor, in LINK&rsquo;s sole determination, are technically incompetent in performing
          the obligations of the Contractor under this Purchase Order .
        </li>
        <li>
          The Contractor shall replace the said Personnel within seven (7) days from the date of
          such written notice from LINK.
        </li>
        <li>
          The Contractor shall seek prior written approval to increase or decrease the level of
          resources dedicated to the Personnel in order to perform the required Specifications, of
          which such approval shall not be unreasonably withheld by LINK, provided always such
          variation shall not impact the Goods and/or Services delivery.
        </li>
      </Level2>
    </li>
  </>
);

export default TermsAndConditions;
